module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-750-Classes-Inactive-9ebdf92a0d409fe692c7a619f7dc99c4.png";